import { DialogActions } from "@mui/material";
import ThemeContext from "components/app/Context";
import { useContext } from "react";
import { accessTypes } from "utils/CommonConstants";
import Button from "../../common/Button";
interface Props {
  handleClose: any;
  handleSubmit: any;
  isMyPlan?: boolean;
}

function ActionButtons(props: Props) {
  const { handleClose, handleSubmit, isMyPlan = false } = props;
  const { isMobileScreen } = useContext(ThemeContext);

  return (
    <DialogActions
      sx={{ width: "100%", display: "flex", justifyContent: isMobileScreen || isMyPlan ? "center" : "end" }}
    >
      <Button variant="secondary" onClick={handleClose} label="Cancel" width={isMyPlan ? "41%" : ""} />
      <Button
        variant="primary"
        label="Save"
        accessType={accessTypes.update}
        width={isMyPlan ? "41%" : ""}
        onClick={handleSubmit}
      />
    </DialogActions>
  );
}

export default ActionButtons;
